(() => {
 'use strict';
 const page=document.querySelector('.bf26-pdp-refined');
 if(!page)return;
 // Visibility class is also used for late-loading chat embeds, without changing app configuration.
 const zones=[...page.querySelectorAll('.product-purchase-panel,.product-support-panel')];
 const visibility=new Map();
 const modalSelectors='[data-size-guide-drawer],[data-size-finder-dialog],[data-product-lightbox],#bf26-offer-dialog';
 const sync=()=>{
   const modalOpen=[...document.querySelectorAll(modalSelectors)].some(e=>e.tagName==='DIALOG'?e.open:!e.hidden);
   document.body.classList.toggle('bf26-pdp-focus',modalOpen||(matchMedia('(max-width:820px)').matches&&[...visibility.values()].some(Boolean)));
 };
 const observer=new IntersectionObserver(entries=>{entries.forEach(e=>visibility.set(e.target,e.isIntersecting));sync();},{threshold:0});
 zones.forEach(e=>observer.observe(e));
 document.querySelectorAll(modalSelectors).forEach(e=>new MutationObserver(sync).observe(e,{attributes:true,attributeFilter:['hidden','data-open','open']}));
 window.addEventListener('resize',sync,{passive:true});
 sync();
})();
